import { ToNullable } from 'utility/types';
import {
  Traveler_traveler,
  Traveler_traveler_travelerAddressesByTravelerId_nodes,
  Traveler_traveler_travelerDietaryRequirementsByTravelerId_nodes,
  Traveler_traveler__travelPolicyAllowances_nodes,
} from './__generated__/Traveler';
import { TravelerAddressUpdateTypeInput, TravelerDietaryRequirementUpdateTypeInput, TravelerPatch } from 'common/types/globalTypes';

export type AddressRowValues =
  ToNullable<Traveler_traveler_travelerAddressesByTravelerId_nodes>;

export type DietaryRequirementsRowValues = ToNullable<
  Omit<
    Traveler_traveler_travelerDietaryRequirementsByTravelerId_nodes,
    'dietaryRequirement'
  > & {
    dietaryRequirementId: number;
    isDescriptionRequired: boolean;
  }
>;

export type TravelerPolicyAllowanceRow = ToNullable<
  Traveler_traveler__travelPolicyAllowances_nodes & {
    isChecked: boolean;
  }
>;

export type TravelerValues = ToNullable<
  Omit<
    Traveler_traveler,
    | 'id'
    | '__typename'
    | '_isTripBreakdownAllowed'
    | '_isApproved'
    | '_urgencyLevel'
    | 'travelerAddressesByTravelerId'
    | 'isIsleSeatPreferred'
    | 'isWindowSeatPreferred'
    | 'travelerDietaryRequirementsByTravelerId'
    | 'travelerPolicyAllowancesByTravelerId'
    | '_isUpdatable'
    | '_isDeletable'
    | '_rowTimestamp'
    | 'travelPolicy'
    | '_travelPolicyAllowances'
    | 'statusType'
    | 'travelerHistoriesByEntityId'
    | 'notesByEntityId'
    | 'entityDocumentsByEntityId'
    | 'isDraft'
    | 'userMessagesByEntityId'
    | 'entityTagsByEntityId'
    | '_isStagedApprovalRequest'
    | '_isApprovalRevocable'
    | '_fullName'
    | 'travelerHost'
    | 'travelPolicy'
    | '_sortName'
    | 'userOccupation'
    | 'approvalHistoriesByEntityId'
    | 'approvalHistorySignaturesByEntityId'
    | 'department'
    | '_isUpdateTravelerOverride'
    | '_isAliasInvoked'
    | '_isAliasOriginalNameViewable'
  > & {
    travelerAddressesByTravelerId: AddressRowValues[];
    seatPreference: string;
    travelerDietaryRequirementsByTravelerId: DietaryRequirementsRowValues[];
    travelerPolicyAllowancesByTravelerId: TravelerPolicyAllowanceRow[];
  }
>;

export type TravelerAddressPatchInput = NonNullable<
  TravelerAddressUpdateTypeInput['travelerAddressPatch']
>;
export type TravelerDietaryRequirementPatchInput = NonNullable<
  TravelerDietaryRequirementUpdateTypeInput['travelerDietaryRequirementPatch']
>;

export const TRAVELER_PATCH_KEYS: ReadonlyArray<keyof TravelerPatch & string> = [
  'firstName',
  'companyOrLastName',
  'frequentFlyerNumber',
  'isIsleSeatPreferred',
  'isWindowSeatPreferred',
  'travelerDepartmentId',
  'travelPolicyId',
  'userOccupationTitleId',
  'travelerCompanionAmount',
  'travelerCompanionTickets',
  'isEconomyClassPreferred',
  'isFirstClassPreferred',
  'isBusinessClassPreferred',
  'isCharterClassPreferred',
  'isPremiumClassPreferred',
  'travelerCompanionMasterId',
];

export const ADDRESS_PATCH_KEYS: ReadonlyArray<keyof TravelerAddressPatchInput & string> = [
  'addressLine1',
  'addressLine2',
  'cityName',
  'countryId',
  'stateRegionId',
  'postalCode',
  'telephoneNumber',
  'emailAddress',
  'isGroundTransferAddress',
  'isDeliveryAddress',
  'isPrimary',
];

export const DIETARY_PATCH_KEYS: ReadonlyArray<
  keyof TravelerDietaryRequirementPatchInput & string
> = ['description', 'dietaryRequirementId'];
